module.exports = __webpack_public_path__ + "media/delete_all.c4ae7711.mp3";